<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="工单详情"
    >
        <div class="container">
            <el-steps align-center v-if="msg && msg.process && msg.process.length > 0" :active="msg.process.filter(item => item.flag === 1).length">
              <el-step v-for="(item, idx) in msg.process" :key="idx" :title="item.name" :description="`${item.value.substring(0, 16)}`"></el-step>
            </el-steps>
            <div class="formCont">
                <el-row v-if="msg.refuse" style="padding-left: 60px">
                    <el-col :span="24">
                        <!-- <el-alert
                            :title="'【拒绝原因】' + msg.refuse"
                            type="error"
                            :closable="false"
                        >
                        </el-alert> -->
                        <div class="refuse-div">
                            【拒绝原因】 {{ msg.refuse }}
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">来源：</div>
                        <div class="content">{{ msg.project_name }}</div>
                    </el-col>
                    <el-col :span="12" v-if="msg.demand_user_name">
                        <div class="label">需求人：</div>
                        <div class="content">
                            <span>{{ msg.demand_user_name }}</span>
                        </div>
                    </el-col>
                </el-row>
                
              <el-row>
                <el-col :span="12">
                  <div class="label">类型：</div>
                  <div class="content">{{ msg.type_cn }}</div>
                </el-col>
                <el-col :span="12">
                  <div class="label">优先级：</div>
                  <div class="content"><el-image v-if="msg.priority" class="list-icon" :src="require(`@/assets/image/p${msg.priority}.svg`)"></el-image> {{ msg.priority_cn }}</div>
                </el-col>
              </el-row>
              <el-row>
                    <el-col :span="12">
                        <div class="label">工单名称：</div>
                        <div class="content bold">{{ msg.name }}</div>
                    </el-col>
                  <el-col :span="12">
                    <div class="label">工单号：</div>
                    <div class="content">{{ msg.order_sn }}</div>
                  </el-col>
                </el-row>
              <el-row>
                  <el-col :span="24">
                      <div class="label">需求内容：</div>
                      <div class="content">
                          <el-input
                              type="textarea"
                              placeholder="暂无需求内容"
                              size="small"
                              v-model="msg.content"
                              :autosize="{ minRows: 8, maxRows: 10 }"
                              readonly
                          >
                          </el-input>
                      </div>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="24">
                      <div class="label">调研内容：</div>
                      <div class="content">
                          <el-input
                              type="textarea"
                              placeholder="暂无调研内容"
                              size="small"
                              v-model="msg.research_content"
                              :autosize="{ minRows: 8, maxRows: 10 }"
                              readonly
                          >
                          </el-input>
                      </div>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="24">
                      <div class="label">原型内容：</div>
                      <div class="content">
                          <el-link :href="`${msg.prototype_content.indexOf('http') == -1 ? 'https://'+msg.prototype_content : msg.prototype_content}`" target="_blank" type="primary" v-if="msg.prototype_content">查看原型</el-link>
                          <span v-else>无</span>
                      </div>
                  </el-col>
              </el-row>

              <el-row v-if="msg.images && msg.images.length > 0">
                  <el-col :span="24">
                      <div class="label">附件内容</div>
                      <div class="content img-list">
                        <!-- <el-image-custom
                          v-for="(_, i) in msg.images"
                          :key="i"
                          :src="msg.images"
                          :width="100"
                          :height="100"
                          :index="i"
                          :border="false"
                          preview
                          fit="cover"
                        /> -->
                        <div style="border: unset; display: block; padding-left: 10px;" v-for="(img, i) in msg.images" :key="i"><el-link :href="img.split(' ').join('%20')" target="_blank">{{img.split('/').pop()}}</el-link></div>
                      </div>
                  </el-col>
              </el-row>

              <!-- 评论 -->
              <el-row v-if="msg.remarks && msg.remarks.length > 0">
                <el-col :span="24">
                  <div class="label"></div>
                    <div class="content">
                      <div class="remarks">
                        <div class="item" v-for="(item, i) in msg.remarks" :key="i">
                          <div class="item-head">
                          <span class="author">{{item.user_name}}</span>
                          <span class="date">{{item.create_time.substring(0, 16)}}</span>
                        </div>
                        <div class="item-content" v-html="item.remark.split('\n').join('<br>')">
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="label">&nbsp;</div>
                  <div class="content">
                    <el-input
                      class="remark-input"
                      type="textarea"
                      placeholder="请输入内容"
                      v-model="newRemark"
                      maxlength="1000"
                      show-word-limit
                      :autosize="{ minRows: 4, maxRows: 10 }"
                      :disabled="posting"
                    >
                    </el-input>
                    <div class="remark-btn">
                      <el-button type="primary" size="medium" :loading="posting" :disabled="newRemark.trim() === ''" @click="post">发表评论</el-button>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
           <el-button  size="small" type="primary" @click="upperData(msg.id)"
           >上一条</el-button
           >
          <el-button id="" size="small" type="primary" @click="nextData(msg.id)"
          >下一条</el-button
          >
            <el-button size="small" @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
import ElImageCustom from "../../../../comon/components/CustomImgUpload/elImageCustom.vue";
export default {
    data() {
        return {
            msg: {},
            newRemark: '',
            posting: false
        };
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        tableData: Array,
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                //  console.log(this.tableData)
                    this.workOrdersList();
                } else {
                  this.msg = {};
                  this.newRemark = '';
                  this.posting = false;
                }
            },
        },
    },
    created() {},
    methods: {
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        workOrdersList() {
            oaApi.workOrdersList({}, "get", this.tableItem.id).then((res) => {
                //console.log(res);
                if (res.code == 200) {
                    this.msg = res.data;
                }
            });
        },
      nextData(id){
      // console.log(id);
        var arr = this.tableData;
       // console.log(arr)
       // console.log(this.tableItem.id)
        var showNextData = false;
        var equalTo = false;
        for(var i=0;i<arr.length;i++){
          if(equalTo){
            if(arr[i].id){
              id = arr[i].id;
              showNextData = true;
          //    console.log(arr[i].id)
           //   console.log('aaa')
              break;
            }
          }
          //如果是当前页就看下一页
          if(id === arr[i].id){
            equalTo = true;
           // console.log(arr[i].id)
          }
        }
        if(showNextData){
       //   console.log(this.tableItem.id);
          // oaApi.workOrdersList({}, "get", id).then((res) => {
          //   //console.log(res);
          //   if (res.code == 200) {
          //     this.msg = res.data;
          //   }
          // });
          this.getData(id)
        }else{
          this.$message.error('已经是最后一条');
        }
      },
      upperData(id){
        var arr = this.tableData;
        var showUpperData = false;
        for(var i=0;i<arr.length;i++){
          //如果是当前页就看下一页
          if(id){
            if(id === arr[i].id){
              if(i>0){
                if(arr[i-1].id){
                  id = arr[i-1].id;
                  showUpperData = true;
                }
              }
              break;
            }
          }
        }
        if(showUpperData){
          oaApi.workOrdersList({}, "get", id).then((res) => {
            if (res.code == 200) {
              this.msg = res.data;
            }
          });
        }else{
          this.$message.error('已经是最前一条');
        }
      },
      post() {
        const {id} = this.tableItem
        this.posting = true
        oaApi.workOrdersPostRemark({
          wo_id: id,
          remark: this.newRemark
        }, 'post').then(res => {
          this.posting = false
          this.newRemark = ''
          this.getData(id)
        }).catch(err => {
          this.posting = false
        })
      },
      getData(id) {
        oaApi.workOrdersList({}, "get", id).then((res) => {
            //console.log(res);
          if (res.code == 200) {
            this.msg = res.data;
          }
        });
      }
    },
    components: { ElImageCustom },
    computed: {
        ...mapState({}),
    },
};
</script>

<style lang="scss" scoped>

::v-deep.el-step {
  .el-step__head {
    &.is-finish {
      color: #eb5202;
      border-color: #eb5202;
    }
  }
  .el-step__main {
    .el-step__title {
      margin-left: calc(50% - 16px);
      text-align: left;
      font-size: 14px;
    }
    .el-step__description {
      word-break: break-word;
      margin-left: calc(50% - 16px);
      text-align: left;
      padding-left: 0;
      padding-right: 0;
    }
  }
}
.list-icon {
  width: 12px!important;
  height: 12px;
  vertical-align:middle;
}

.bold {
  font-weight: bold;
}

.content.img-list {
  >div {
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 2px;
    margin-right: 10px;

    ::v-deep .el-image {
      display: block;
    }
  }
}

.remarks {
  margin-top: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
  text-align: left;

  .item {
    padding-top: 15px;
    padding-bottom: 15px;

    .item-head {
      margin-bottom: 10px;

      .author {
        color: #064777;
        font-size: 13px;
      }

      .date {
        color: #999;
        font-size: 12px;
        margin-left: 15px;
      }
    }

    &+.item {
      border-top: 1px dotted #ddd;
    }
  }
}
::v-deep.remark-input {
  &.el-textarea {
    .el-input__count {
      bottom: -30px;
      left: 10px;
      font-size: 14px;
      width: 100px;
      background-color: transparent;
    }
  }
}
.remark-btn {
  background-color: #f7f7f7;
  height: 30px;
  width: 100%;
  border: 1px solid #c0c6cc;
  border-top: 0;
  text-align: right;
  height: 36px;
  margin-top: -1px;
  box-sizing: border-box;

  .el-button {
    border-radius: 0!important;
  }
}
</style>
